let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hE0FA")).then(() => parcelRequire('gPonu'));